
// Function to shuffle a string (Fisher-Yates algorithm)
const shuffleString = (str) => {
    const array = str.split('');
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array.join('');
};
export const generateStrongPassword = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const specialChars = '!@#$%^&*()-_=+[{]}|;:,<.>/?';
    let strongPassword = '';

    for (let i = 0; i < 9; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        strongPassword += chars[randomIndex];
    }

    const randomSpecialChar = specialChars[Math.floor(Math.random() * specialChars.length)];
    strongPassword += randomSpecialChar;

    return shuffleString(strongPassword);
};